import type {
    AwsSignedUploadResponse
} from 'x1-base/types';

// Generic Types

export type GenericObject<T, TT extends string | number | symbol = string | number> = Record<TT, T>;
export type GenericStringObject = GenericObject<string>;
export type GenericUidReference = { uid: string };


export type ObjectWithAtLeastRequiredProps<T, TT = (number | string)> = T & {
    [key: string]: TT;
};



// Lists

export interface SelectListItem<T = any> {
    text?: string;
    label?: string;
    value: T;
}



// File Upload
// TODO Move me


export type FileUploadCompleteResponse = [File, AwsSignedUploadResponse];

export type FileUploadInputValue = Record<string, AwsSignedUploadResponse>;


// Router

export interface RoutableBase {
    text: string;
    disabled: boolean;
    to: string;
    nuxt: boolean;
    activeClass: string;
    append: boolean;
    exact: boolean | undefined;
    exactPath: boolean;
    exactActiveClass: string;
    link: boolean;
    href: string | object;
    replace: boolean;
    ripple: boolean | object;
    tag: string;
    target: string;
}

export type Routable = Partial<RoutableBase>;



// Network

export enum HttpStatusCodeType {
    UNKNOWN,
    INFORMATIONAL,
    SUCCESSFUL,
    REDIRECTION,
    CLIENT,
    SERVER
}
